import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 2, height: 16, x: 7, fill: "currentColor", rx: 1 }), /* @__PURE__ */ React.createElement("rect", { width: 2, height: 16, x: -9, fill: "currentColor", rx: 1, transform: "rotate(-90)" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
